import React from 'react'
import useScrollReveal from '../../hooks/useScrollReveal'

const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin']
const INCOME_HEIGHTS = [70, 65, 80, 75, 72, 85]
const EXPENSE_HEIGHTS = [50, 55, 60, 45, 52, 48]

export default function DashboardPreview() {
  const [ref, isVisible] = useScrollReveal()

  return (
    <section className={`section-padding reveal${isVisible ? ' revealed' : ''}`} ref={ref}>
      <h2 className="section-title">Des insights qui comptent.</h2>
      <p className="section-subtitle">Analysez vos habitudes de dépenses avec des visualisations claires et actionables.</p>

      <div className="landing-dashboard">
        <div className="landing-dashboard__mockup">
          <div className="landing-dashboard__kpis">
            <div className="landing-dashboard__kpi">
              <div className="landing-dashboard__kpi__label">Revenus du mois</div>
              <div className="landing-dashboard__kpi__value landing-dashboard__kpi__value--income">+3 250,00 €</div>
            </div>
            <div className="landing-dashboard__kpi">
              <div className="landing-dashboard__kpi__label">Dépenses du mois</div>
              <div className="landing-dashboard__kpi__value landing-dashboard__kpi__value--expense">-1 847,30 €</div>
            </div>
            <div className="landing-dashboard__kpi">
              <div className="landing-dashboard__kpi__label">Solde net</div>
              <div className="landing-dashboard__kpi__value landing-dashboard__kpi__value--balance">+1 402,70 €</div>
            </div>
          </div>

          <div className="landing-dashboard__charts">
            <div className="landing-dashboard__chart">
              <div className="landing-dashboard__chart__title">Répartition des dépenses</div>
              <div className="landing-dashboard__donut" />
              <div className="landing-dashboard__donut-legend">
                <div className="landing-dashboard__legend-item">
                  <div className="landing-dashboard__legend-dot" style={{ background: 'var(--dark-solid)' }} />
                  Logement
                </div>
                <div className="landing-dashboard__legend-item">
                  <div className="landing-dashboard__legend-dot" style={{ background: 'var(--dark-success)' }} />
                  Alimentation
                </div>
                <div className="landing-dashboard__legend-item">
                  <div className="landing-dashboard__legend-dot" style={{ background: 'var(--dark-warning)' }} />
                  Transport
                </div>
                <div className="landing-dashboard__legend-item">
                  <div className="landing-dashboard__legend-dot" style={{ background: 'var(--dark-danger)' }} />
                  Loisirs
                </div>
              </div>
            </div>

            <div className="landing-dashboard__chart">
              <div className="landing-dashboard__chart__title">Revenus vs Dépenses</div>
              <div className="landing-dashboard__bars">
                {MONTHS.map((month, i) => (
                  <div className="landing-dashboard__bar-group" key={month}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '3px', height: '100px' }}>
                      <div
                        className="landing-dashboard__bar"
                        style={{ height: `${INCOME_HEIGHTS[i]}%`, background: 'var(--dark-success)' }}
                      />
                      <div
                        className="landing-dashboard__bar"
                        style={{ height: `${EXPENSE_HEIGHTS[i]}%`, background: 'var(--dark-danger)' }}
                      />
                    </div>
                    <div className="landing-dashboard__bar-label">{month}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
